import { render, staticRenderFns } from "./ModalPersonal.vue?vue&type=template&id=30c14333&"
import script from "./ModalPersonal.vue?vue&type=script&lang=js&"
export * from "./ModalPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports